import * as React from 'react'
import { FormValue, FileTextValue } from '../../reducers/form-values'
import { inputValueChangeFn } from './form-type-selector'
import { nl2br, targetBlankifyLinks } from '../utils'
import { errorMsg } from './build-error-msg'

export function buildSelect (data, value: FileTextValue, inputValueChange: inputValueChangeFn): JSX.Element {
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => inputValueChange(data.qid, 'textInput', e.target.value)
  const labelHtml = {
    __html: nl2br(targetBlankifyLinks(data.label))
  }

  let options = data.field_options.options || []
  if (data.field_options.placeholderText) {
    options = [
      {
        label: data.field_options.placeholderText,
        value: ''
      },
      ...options
    ]
  }

  return (
    <div className={data.className ? data.className : 'col-xs-12'} key={data.qid}><div
    className={'input-line input-select'}>
      {data.label && <label
      htmlFor={data.qid}><span dangerouslySetInnerHTML={labelHtml}></span> <span className='fieldRequired'>{data.required && '*'}</span></label>}
      <select
        id={data.qid}
        name={data.qid}
        onChange={onChange}
        value={value.value}
        aria-required={data.required}
        aria-invalid={!!data.errorMessage}
        >
        {options.map((option) =>
          <option
            key={option.value}
            value={option.value}
          >{option.label}</option>
        )}
      </select>
      {data.errorMessage &&
        errorMsg(data.qid, data.errorMessage)}
    </div></div>
  )
}
